import { EventEmitter } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Observable } from "rxjs";
import { UserSetup } from "src/app/core/model/v2/practitioner/UserSetup";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Address } from "../../../../core/model/v2/practice/address";
import { Practitioner } from "../../../../core/model/v2/practitioner/practitioner";
import { PracticeService } from "../../../../core/services/v2/practice.service";

export abstract class PractitionerSetupBase {
  practitioner: Practitioner;
  isEditing = false;
  showWarning = false;
  showError = false;
  errorMessage: string;
  npi: string;
  showRoleSelector: boolean = true;

  constructor(
    protected practitionerRoleCategory: string,
    private practiceService: PracticeService,
    private loaderService: WindowLoaderService,
    private matSnackBar: MatSnackBar
  ) {}

  abstract onSaveSuccess(): void;
  abstract onSearchSuccess(): void;
  abstract availableRoles: string[];

  closeSidebar(): void {
    this.destroyComponentManually();

    this.npi = "";
    this.isSidebarOpened = false;
    this.isSidebarOpenedChange.emit();
  }

  abstract isSidebarOpened: boolean;
  abstract isSidebarOpenedChange: EventEmitter<boolean>;

  destroyComponentManually() {
    this.showWarning = false;
    this.showError = false;
    this.practitioner = undefined;
    this.errorMessage = "";
    this.isEditing = false;
  }

  setPractitionerToEdit(user: UserSetup): void {
    this.isEditing = true;
    this.practitioner = user.practitioner;
    this.practitioner.role = user.role;
    this.practitioner.healthSystemIds = user.healthSystemIds;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  search() {
    if (this.isEditing || !this.npi) return;

    this.loaderService.show();
    this.searchGlobalPractitioner.subscribe(
      (response) => {
        response.id = 0;
        this.practitioner = response;
        this.CreatePractitionerAddressFromLocation();
        this.onSearchSuccess();
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }
  enterManually() {
    this.practitioner = new Practitioner();
    this.practitioner.id = 0;
    this.onSearchSuccess(); //set role
    if (this.practitionerRoleCategory == "Attorney") {
      this.practitioner.practitionerType = 1;
    } else if (this.practitionerRoleCategory == "CaseManager") {
      this.practitioner.practitionerType = 2;
    }
    this.CreatePractitionerAddressFromLocation();
  }

  searchGlobalPractitioner = new Observable<Practitioner>((observer) => {
    this.practiceService.searchPhysicians(this.npi).subscribe(
      (response) => {
        if (!response) {
          this.showWarning = true;
          observer.error();
        } else {
          if (response["response"]["isSuccess"]) {
            this.showError = false;
            if (!response.healthSystemIds) {
              response.healthSystemIds = [];
            }
            observer.next(response);
          } else {
            this.showError = true;
            observer.error();
          }
        }
      },
      (error) => {
        observer.error(error);
        this.matSnackBar.open(error.error.message, "Ok");
      },
      () => {
        observer.complete();
      }
    );
  });

  onSave(selectedHealthSystem: any): void {
    // if(!this.practitioner.role)
    // {
    //   this.showError = true;
    //   return;
    // }

    if (this.isEditing) {
      this.updateService(selectedHealthSystem);
    } else {
      this.saveService(selectedHealthSystem);
    }
  }

  saveService(selectedHealthSystem): void {
    this.loaderService.show();
    this.practitioner.active = true;
    if (selectedHealthSystem) {
      if (selectedHealthSystem.practiceType == 2) {
        this.practitioner.legalPracticeId = selectedHealthSystem.id;
      }
    }
    const practReq = {
      practitioners: new Array<Practitioner>(this.practitioner),
    };

    this.practiceService.addPractitioners(practReq).subscribe(
      (response) => {
        if (response.isSuccess) {
          //TODO reload the health organization component
          this.onSaveSuccess();
          this.closeSidebar();
        } else {
          // this.errorMessage = 'Error: ' + response.message;
          this.matSnackBar.open(response.message, "Ok");
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
        this.matSnackBar.open(error.error.message, "Ok");
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  private CreatePractitionerAddressFromLocation() {
    if (this.practitioner.location) {
      this.practitioner.address = new Address();
      this.practitioner.address.line = this.practitioner.location.address1;
      this.practitioner.address.line2 = this.practitioner.location.address2;
      this.practitioner.address.city = this.practitioner.location.city;
      this.practitioner.address.state = this.practitioner.location.state;
      this.practitioner.address.zipCode = this.practitioner.location.zipCode;
      this.practitioner.address.country = this.practitioner.location.country;
    }
  }

  updateService(selectedHealthSystem): void {
    this.loaderService.show();
    this.practitioner.active = true;
    if (selectedHealthSystem) {
      if (selectedHealthSystem.practiceType == 2) {
        this.practitioner.legalPracticeId = selectedHealthSystem.id;
      }
    }
    this.practiceService.updatePractitioner(this.practitioner).subscribe(
      (response) => {
        if (response.isSuccess) {
          //TODO reload the health organization component
          this.onSaveSuccess();
          this.closeSidebar();
        } else {
          // this.errorMessage = 'Error: ' + response.message;
          this.matSnackBar.open(response.message, "Ok");
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
        this.matSnackBar.open(error.error.message, "Ok");
      },
      () => {
        this.loaderService.hide();
      }
    );
  }
}
